/**
 * BISI Engineering Website - Main App Component
 *
 * Root component that sets up routing for all pages.
 *
 * @see src/pages/     - Page components
 * @see src/constants/ - Route & theme configuration
 */

import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import './styles/global.css';

import { ScrollProgress } from './components/ui/ScrollProgress';
import { ScrollNav } from './components/ui/ScrollNav';
import { Navbar } from './components/layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import WorkPage from './pages/WorkPage';
import ClientsPage from './pages/ClientsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import NotFoundPage from './pages/NotFoundPage';

// -----------------------------------------------------------------------------
// Scroll to top on route change
// -----------------------------------------------------------------------------

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

// -----------------------------------------------------------------------------
// App
// -----------------------------------------------------------------------------

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollProgress />
      <ScrollNav />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<WorkPage />} />
        <Route path="/projects" element={<WorkPage />} />
        <Route path="/team" element={<WorkPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
